
export default {
  name: 'BarcodeDisplay',
  props: {
    productId: { type: String, required: true },
    code: { type: String, default: '' },
    downloadable: { type: Boolean, default: false }
  },
  data () {
    return { svgData: '', loading: false, error: '' }
  },
  mounted () {
    // 管理端自动生成，用户端点击按钮手动生成
    if (this.downloadable && this.productId && this.code) this.generate()
  },
  methods: {
    async generate () {
      if (!this.productId) { this.error = '缺少商品ID'; return }
      this.loading = true; this.error = ''
      try {
        const token = localStorage.getItem('token')
        const res = await this.axios.get(`/products/${this.productId}/barcode`, {
          params: { format: 'svg' },
          headers: token ? { Authorization: `Bearer ${token}` } : {},
          responseType: 'text'
        })
        if (typeof res.data === 'string' && res.data.startsWith('<svg')) {
          this.svgData = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(res.data)))
        } else {
          this.error = '条码生成失败'
        }
      } catch (err) {
        this.error = (err.response?.data?.message) || '生成失败'
      } finally { this.loading = false }
    },
    async downloadPNG () {
      try {
        const token = localStorage.getItem('token')
        const res = await this.axios.get(`/products/${this.productId}/barcode`, {
          params: { format: 'png' },
          headers: token ? { Authorization: `Bearer ${token}` } : {},
          responseType: 'blob'
        })
        const blob = new Blob([res.data], { type: 'image/png' })
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url; a.download = `${this.code || 'barcode'}.png`
        document.body.appendChild(a); a.click()
        document.body.removeChild(a); URL.revokeObjectURL(url)
      } catch (err) { alert('下载失败') }
    }
  }
}
